import { createGlobalStyle } from "styled-components";
import { fontFaces } from "./fonts";
import "./reset.css";

export const GlobalStyle = createGlobalStyle`
  ${fontFaces}
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Inter";
  }

  *:focus {
      outline: none;
  }

  html {
    width: 100vw;
    height: 100vh;
  }

  body {
    min-height: 100vh;
    background-color: ${(props) => props.theme.background}; 
  }

  html, body {
    width: 100%;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
  }

  h5 {
    font-size: 24px;
    line-height: 32px;
    max-width: 56%;
    font-family: "everettmedium";
    font-weight: 400;
  }

  .tippy-tooltip.tomato-theme {
    background-color: tomato;
    color: yellow;
  }

  p {
    font-family: "Inter";
    font-weight: 400;
  }

  label {
    font-family: "everettmedium";
    font-weight: 400;
  }

  h1 {
    letter-spacing: -5px;
    font-family: "everettmedium";
    font-weight: 400;
  }
  
  h2 {
    letter-spacing: -2px;
    font-family: "everettmedium";
    font-weight: 400;
  }
`;